var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:(_vm.appStyle)},[_c('v-main',{attrs:{"id":"main"}},[(_vm.screenshot)?_c('preview-phone',[_c('router-view')],1):_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }